import { ReferenceLine } from "recharts";
import type { ApplyMarker } from "./operational-loop-adapter";
import { LOOP_STAGE_ACCENT } from "./chart-shared";

// Where each applied recipe landed on the shared step grid — the same thin dashed vertical the
// Trendi panel uses for its annotations (TrendView.tsx), in the recipe stage's own accent so it
// reads as "a recipe happened here" on any of the loop's charts. Drawn under the data lines.
//
// A plain function called inline, not a component — same Recharts 2 constraint as nowMarker
// (NowMarker.tsx): only direct/flattened children are drawn.
export function applyMarkers(
  markers: ApplyMarker[],
  yAxisId?: string,
  labeled = false,
) {
  return markers.map((m) => (
    <ReferenceLine
      key={`apply-${m.key}`}
      x={m.key}
      yAxisId={yAxisId}
      stroke={LOOP_STAGE_ACCENT.recipe}
      strokeDasharray="3 2"
      strokeOpacity={0.7}
      {...(labeled
        ? {
            label: {
              value: `resepti ${m.label}`,
              position: "insideBottomLeft" as const,
              fill: LOOP_STAGE_ACCENT.recipe,
              fontSize: 9,
            },
          }
        : {})}
    />
  ));
}
